import { useQueryClient } from "@tanstack/react-query";
import { reaction } from "mobx";
import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { useCommandMenuStore } from "../command-menu-context";

import { prefetchSmartTableNavigation } from "@/components/UnifiedRegistry/hooks/useSmartTableNavigationPrefetch";
import { useAuth } from "@/context/auth-context";
import { withPreservedWorkspaceSearch } from "@/utils/requestLogUrlParams";

const smartTablePathRegex = /^\/workspace\/(\d+)\/smart-tables\/([^/?#]+)/;

const useNavigateOnSelect = () => {
  const commandMenu = useCommandMenuStore();
  const navigate = useNavigate();
  const location = useLocation();
  const locationRef = useRef(location);
  const queryClient = useQueryClient();
  const userToken = useAuth()?.userToken ?? "";
  locationRef.current = location;

  useEffect(() => {
    const dispose = reaction(
      () => commandMenu.pendingRedirect,
      redirectPath => {
        if (redirectPath) {
          const match = redirectPath.match(smartTablePathRegex);
          if (match) {
            prefetchSmartTableNavigation({
              queryClient,
              userToken,
              workspaceId: Number(match[1]),
              tableId: match[2],
            });
          }

          navigate(withPreservedWorkspaceSearch(redirectPath, locationRef.current.search));
          commandMenu.completeRedirect();
        }
      },
    );

    return dispose;
  }, [commandMenu, navigate, queryClient, userToken]);
};

export default useNavigateOnSelect;
